export function createOffice(data) {
    let { createOfficeRequest, createOfficeError, createOfficeResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'create_office',
        this.createBundle('create_office', { office: data }, this.POST, createOfficeRequest, createOfficeResult, createOfficeError)
    )
}
